// extracted by mini-css-extract-plugin
export default {"layout":"MainLayout_layout__YTf0n","main":"MainLayout_main__2hqH5"};